import { Avatar, Box, type SxProps, type Theme } from '@mui/material';
import SimpleUser from '../../../features/auth/types/SimpleUser';
import User from '../../../features/auth/types/User';
import { avatarBase64Converter } from '../../utils/imgBase64Converter';

const UserAvatar = ({
	player,
	height = 40,
	sx,
	avasx,
}: {
	player: User | SimpleUser | undefined;
	height?: number;
	sx?: SxProps<Theme>;
	avasx?: SxProps<Theme>;
}): JSX.Element => {
	return (
		<Box sx={{ mb: 0.8, ml: 0.5, display: 'flex', alignItems: 'center', fontWeight: 600, ...sx }}>
			<Avatar
				sx={{ mr: 0.5, height, width: height, border: 1, borderColor: 'gray', ...avasx }}
				variant="circular"
				alt="user_avatar"
				src={avatarBase64Converter(player?.avatar)}
			/>
			{player?.username}
		</Box>
	);
};

export default UserAvatar;
